/**
 * useSocketConnection Hook
 * Subscribes to the chat websocket connection state for UI indicators.
 */

import { useSyncExternalStore } from 'react';
import socketClient, { type SocketConnectionState } from '@/services/socket.client';

export const useSocketConnection = (): SocketConnectionState => {
  return useSyncExternalStore(
    (onStoreChange) => {
      socketClient.onConnectionStateChange(onStoreChange);
      return () => socketClient.offConnectionStateChange(onStoreChange);
    },
    () => socketClient.getConnectionState(),
    () => 'connected' as SocketConnectionState
  );
};
